import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Service.scss';

// @injectIntl
export default class Service extends Component {
    static propTypes = {
        selected: PropTypes.bool,
        service: PropTypes.any,
        handleServiceSelect: PropTypes.func,
    }

    handleServiceSelect = () => {
        const { handleServiceSelect, service } = this.props;
        handleServiceSelect(service.get('id'));
    }

    render() {
        const { service, selected } = this.props;

        const img = service.getIn(['image', 'path']);
        const type = service.get('alias').split('.')[1];

        return (
            <div
                className={classNames(styles.service, selected ? styles.selected : null )}
                onClick={this.handleServiceSelect}
            >
                <img src={`/${img}`} role='presentation' className={styles.image} />
                <h4><FormattedMessage id={`frontend.form_selector_service.label.${type}`} /></h4>
                <p><FormattedMessage id={`frontend.form_selector_service.hint.${type}`} /></p>
            </div>
        );
    }
}
